import { z } from "zod";
import { mediaListSchema } from "../common.js";

export const VT_CLIENT_TASKS_OPTIONS = [
  "decaissement",
  "remblai",
  "nettoyage",
  "plans_plomberie",
  "nivellement",
  "revetements",
  "ouverture_tranchees",
  "debroussaillage",
  "fournitures_chantier",
  "abattage",
  "autre",
] as const;
export type VtClientTaskOption = (typeof VT_CLIENT_TASKS_OPTIONS)[number];

export const VT_CLIENT_TASK_OPTION_LABELS: Record<VtClientTaskOption, string> = {
  decaissement: "Décaissement",
  remblai: "Remblai",
  nettoyage: "Nettoyage",
  plans_plomberie: "Plans plomberie",
  nivellement: "Nivellement",
  revetements: "Revêtements",
  ouverture_tranchees: "Ouverture des tranchées",
  debroussaillage: "Débroussaillage",
  fournitures_chantier: "Fournitures chantier",
  abattage: "Abattage",
  autre: "Autre",
};

export const VT_WASTE_MANAGEMENT = ["greenkub", "client"] as const;
export type VtWasteManagement = (typeof VT_WASTE_MANAGEMENT)[number];

export const VT_WASTE_MANAGEMENT_LABELS: Record<VtWasteManagement, string> = {
  greenkub: "Greenkub",
  client: "Client",
};

export const VT_BUDGET_INTENTS = ["upsell", "downsell"] as const;
export type VtBudgetIntent = (typeof VT_BUDGET_INTENTS)[number];

/** Préfixe d'`optionId` d'une ligne hors catalogue (« ligne libre » du cockpit). */
export const VT_BUDGET_FREE_LINE_PREFIX = "libre:";

/**
 * Une ligne d'upsell / downsell. Même mécanique que l'avenant technique du
 * cockpit (« VT à instruire », 0368) : une option du catalogue PVM, OU une
 * ligne libre (`optionId` = `libre:<uuid>`, sans code, prix facultatif — 0 =
 * « prix à fixer »), quantité au demi près (des mètres de tranchée).
 * `motif` : le fait de VT qui a proposé la ligne (règle du cockpit).
 */
export const budgetSelectionSchema = z.object({
  optionId: z.string().min(1),
  code: z.string(),
  label: z.string().min(1),
  intent: z.enum(VT_BUDGET_INTENTS),
  unit: z.string().nullable().optional(),
  unitPrice: z.number().nonnegative(),
  quantity: z.number().positive(),
  notes: z.string().optional(),
  description: z.string().nullable().optional(),
  motif: z.string().optional(),
});
export type VtBudgetSelection = z.infer<typeof budgetSelectionSchema>;

export const vtClientWorksSchema = z
  .object({
    clientTasks: z
      .object({
        enabled: z.boolean().optional(),
        selections: z.array(z.enum(VT_CLIENT_TASKS_OPTIONS)).optional(),
        otherNote: z.string().optional(),
      })
      .optional(),
    clientValidation: z
      .object({
        hasIssues: z.boolean().optional(),
        issues: z.array(z.string()).optional(),
        notes: z.string().optional(),
      })
      .optional(),
    clientRequests: z.string().optional(),
    requestsMedia: mediaListSchema.optional(),
    wasteManagement: z.enum(VT_WASTE_MANAGEMENT).optional(),
    clientWorksRemarks: z.string().optional(),
    budgetSelections: z.array(budgetSelectionSchema).optional(),
    /** Options proposées par une règle et ÉCARTÉES par le relais (« ∅ ») : elles
        ne sont plus reproposées, et le cockpit ne les remonte pas au BE. */
    budgetDismissed: z.array(z.string()).optional(),
  })
  .partial();

export type VtClientWorks = z.infer<typeof vtClientWorksSchema>;
